// query to check whether curated definition exists
import type { DefinitionConfluenceScope, DefinitionJiraScope } from '../types';

export interface CuratedDefinitionType {
	definition?: string;
	accountId?: string;
	referenceUrl?: string | null;
	editor?: {
		name: string;
		accountId: string;
	} | null;
	confluenceEntity?: {
		id: string;
		type: string | null;
		title: string | null;
		space: {
			name: string | null;
		} | null;
	} | null;
	message?: string | null;
	__typename: string;
}

export interface CuratedDefinitionQueryType {
	knowledgeDiscovery: {
		definition: CuratedDefinitionType;
	};
}

export interface CuratedDefinitionQueryVariables {
	workspaceId: string;
	keyPhrase: string;
	confluenceScopeId?: DefinitionConfluenceScope;
	jiraScopeId?: DefinitionJiraScope;
}

export const CURATED_DEFINITION_OPERATION_NAME = 'CuratedDefinitionQuery';
export const CuratedDefinitionQuery: '\nquery CuratedDefinitionQuery(\n\t\t$workspaceId: String!\n\t\t$keyPhrase: String!\n\t\t$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence\n\t\t$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira\n\t) {\n\t\tknowledgeDiscovery {\n\t\t\tdefinition(\n\t\t\t\tworkspaceId: $workspaceId\n\t\t\t\tkeyPhrase: $keyPhrase\n\t\t\t\tconfluenceScopeId: $confluenceScopeId\n\t\t\t\tjiraScopeId: $jiraScopeId\n\t\t\t) @optIn(to: "KnowledgeDiscovery Get definition") {\n\t\t\t\t__typename\n\t\t\t\t... on KnowledgeDiscoveryDefinition {\n\t\t\t\t\tdefinition\n\t\t\t\t\taccountId\n\t\t\t\t\tcreatedAt\n\t\t\t\t\teditor {\n\t\t\t\t\t\t... on User {\n\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\taccountId\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\treferenceUrl\n\t\t\t\t\tconfluenceEntity {\n\t\t\t\t\t\t... on ConfluencePage {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\ttype\n\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\tspace {\n\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t... on ConfluenceBlogPost {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\ttype\n\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\tspace {\n\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t... on QueryError {\n\t\t\t\t\tmessage\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n' = `
query ${CURATED_DEFINITION_OPERATION_NAME}(
		$workspaceId: String!
		$keyPhrase: String!
		$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
		$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
	) {
		knowledgeDiscovery {
			definition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				confluenceScopeId: $confluenceScopeId
				jiraScopeId: $jiraScopeId
			) @optIn(to: "KnowledgeDiscovery Get definition") {
				__typename
				... on KnowledgeDiscoveryDefinition {
					definition
					accountId
					createdAt
					editor {
						... on User {
							name
							accountId
						}
					}
					referenceUrl
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
